import { Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { FunnelImage } from 'core/flow/entities';
import {
  CardStyled,
  ImageStyled,
  TitleStyled,
  CardWrapperStyled,
  CardAchievementVariant,
} from './styled';

type CardAchievementProps = {
  text: string;
  title?: string;
  image?: FunnelImage;
  variant?: CardAchievementVariant;
  className?: string;
};

export const CardAchievement = ({
  text,
  image,
  title,
  variant = 'accent',
  className,
}: CardAchievementProps) => {
  return (
    <CardWrapperStyled className={className}>
      <CardStyled variant={variant}>
        {image?.src && (
          <ImageStyled
            src={image.src}
            alt={image.alt}
            width={image.width || 32}
            height={image.height || 32}
          />
        )}
        <div>
          {title && (
            <TitleStyled variant="bodyLargeSemiBold" dangerouslySetInnerHTML={prepareHtml(title)} />
          )}
          <Typography variant="bodyMediumRegular" dangerouslySetInnerHTML={prepareHtml(text)} />
        </div>
      </CardStyled>
    </CardWrapperStyled>
  );
};
